import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Button,
    message,
    ProTableOt,
    useProTableOt,
    setParamsFilter,
    DeleteButton as OtDeleteButton
} from "../../ui/ot";
import { Card, CardContent, CardDescription, CardHeader, CardTitle, CardFooter } from '../../ui/card'
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import useWindowSize from '../../online_public_catalog_query_construction/controllers/window_size';
import { useTranslation } from "react-i18next";
import { Star, Edit, Trash2, History } from "lucide-react"
import BookReviewForm from "./book_review_form";
const BookReviews = ({
    keyPrefix = "library.reader_reviews",
    rowKey = "review_id",
    showMode = "card",//card page
    canPost, //不可新增
    canPatch = true, //只有讀者可以修改自己的評論
    canDelete = true, //管理員可以完整刪除 讀者刪除只會變為刪除狀態
    isPatchDelete = true,
    isSelf = true


}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const actionRef = useRef();

    const columns = [
        {
            title: t(`book_title`),
            dataIndex: 'bib_title',
            key: 'bib_title',
        },
        {
            title: t(`reviewer`),
            dataIndex: 'create_user_name',
            key: 'create_user_name',
        },
        {
            title: t(`rating`),
            dataIndex: 'star',
            key: 'star',
            render: ((text, record, index) => {
                console.log({ text, index, record })
                return <Row justify={"center"}>
                    <Col  >
                        <div className="flex">  {renderStars(text)}</div>
                    </Col></Row>
            })
        },
        {
            title: t(`review_time`),
            dataIndex: 'create_time',
            key: 'create_time',
        },
        {
            title: t(`review_content`),
            dataIndex: 'review_content',
            key: 'review_content',
        },
    ];
    const showCard = {
        xxl: 4,
        xl: 3,
        lg: 3,
        md: 2,
        sm: 2,
        xs: 1,
    }
    const [modalOpen, setModalOpen] = useState(false);
    //星星
    const renderStars = (rating) => {
        return Array(5)
            .fill(0)
            .map((_, i) => (
                <Star key={i} className={`h-4 w-4 ${i < rating ? "fill-yellow-400 text-yellow-400" : "text-gray-300"}`} />
            ))
    }

    // 螢幕大小斷點判斷
    function getBreakpoint(width) {
        const breakpoints = {
            xxl: 1600,
            xl: 1200,
            lg: 992,
            md: 768,
            sm: 576,
            xs: 0,
        };
        if (width >= breakpoints.xxl) return 'xxl';
        if (width >= breakpoints.xl) return 'xl';
        if (width >= breakpoints.lg) return 'lg';
        if (width >= breakpoints.md) return 'md';
        if (width >= breakpoints.sm) return 'sm';
        return 'xs';
    }
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success(t('add_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success(t('modify_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success(t('delete_success'));
                actionRef.current.reloadAndRest();
            }
            if (axiosMode !== "get") {
                setModalOpen(false)
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error(t('add_failure'));
                actionRef.current.reloadAndRest();

            } else if (axiosMode === "patch") {
                message.error(t('modify_failure'));
                actionRef.current.reload();
            } else if (axiosMode === "delete") {
                message.error(t('delete_failure'));
                actionRef.current.reloadAndRest();
            }
            if (axiosMode !== "get") {
                setModalOpen(false)
            }
        }
    };
    //取得螢幕大小
    const { width, height } = useWindowSize();
    const reviewController = useCRUDController({
        apiRoute: isSelf ? "/library/review_self" : "/library/review",
        onFinish: onFinish
    })
    const reviewPatchController = useCRUDController({
        apiRoute: "/library/review",
        onFinish: onFinish
    })

    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns,
    });
    useEffect(() => {
        checkAll();
    }, []);
    return (<Row gutter={[16, 0]}>
        <Col span={24}>
            <ProTableOt
                setModalOpen={setModalOpen}
                modalOpen={modalOpen}
                formMode={true}
                PropsPatchForm={<BookReviewForm />}
                check={check}
                setCheck={setCheck}
                reloadButton={false}
                manageColumnsButton={false}
                showSearch={true}
                // readonly={true}
                actionRef={actionRef}
                showMode={showMode}
                headerTitle={
                    <>

                    </>
                }
                columns={columns}
                rowKey={rowKey}
                toolBarRender={() => {
                    return [
                    ]
                }}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {
                    let newParams = {};
                    let order = setOrders(sort);
                    newParams = {
                        ...params,
                        ...newParams,
                        order,
                        size: params?.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key,
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    return reviewController.getData(newParams)
                }}
                cardModeSetting={{
                    columnsCount: showCard[getBreakpoint(width)],
                    singleRowHeight: "320px",
                }}
                cardRender={(review, { PatchButton, DeleteButton }) => {
                    return (
                        <Card key={review?.id} className="overflow-hidden border-[#e8e0d8] bg-white">
                            <CardHeader className="p-4">
                                <div className="flex justify-between items-start">
                                    <div className="space-y-1">
                                        <CardTitle className="line-clamp-1">{review?.bib_title}</CardTitle>
                                        <CardDescription>{review?.bib_author}</CardDescription>
                                    </div>
                                    <div className="flex">
                                        {[...Array(5)].map((_, i) => (
                                            <Star
                                                key={i}
                                                className={`h-4 w-4 ${i < review?.star ? "fill-[#e8a05c] text-[#e8a05c]" : "text-gray-300"}`}
                                            />
                                        ))}
                                    </div>
                                </div>
                            </CardHeader>
                            <CardContent className="p-4 pt-0">
                                <div className="flex gap-4">
                                    <div className="shrink-0">
                                        <img
                                            src={"https://media.taaze.tw/showLargeImageByIsbn.ashx?height=100%&isbn=" +
                                                review?.bibitem_isbn}
                                            alt={review?.bib_title}
                                            className="h-[120px] w-[80px] rounded-md object-cover"
                                        />
                                    </div>
                                    <div className="flex flex-col justify-between">
                                        <div className="space-y-2">
                                            <div className="text-sm text-muted-foreground">
                                                {t('review_time')}: {(review?.create_time)}
                                            </div>
                                            {review?.last_edit_time && (
                                                <div className="text-sm text-muted-foreground flex items-center">
                                                    <History className="mr-1 h-3 w-3" />
                                                    {t('last_edited')}: {(review?.last_edit_time)}
                                                </div>
                                            )}
                                            <p className="text-sm line-clamp-4">{review?.review_content}</p>
                                        </div>
                                    </div>
                                </div>
                            </CardContent>
                            <CardFooter className="p-4 pt-0 flex gap-2">
                                {
                                    !!review?.is_deleted ?
                                        <>
                                            <Button
                                                disabled={true}
                                                type="default"
                                                className="flex-1 border-[#e8e0d8]  "

                                            >
                                                評論已經被刪除
                                            </Button>
                                        </>
                                        : <>
                                            {canPatch && React.cloneElement(PatchButton, { className: "flex-1 border-[#e8e0d8] text-[#e8a05c] hover:bg-[#f0e6da] hover:text-[#e8a05c]" })}
                                            {canDelete && (
                                                isPatchDelete ?
                                                    <OtDeleteButton
                                                        className="flex-1 border-[#e8e0d8] text-[#e8a05c] hover:bg-[#f0e6da] hover:text-[#e8a05c]"
                                                        onConfirm={() => {
                                                            let data = [
                                                                {
                                                                    "review_id": review?.review_id,
                                                                    is_deleted: 1
                                                                }
                                                            ]
                                                            reviewPatchController.patchData(data)
                                                        }}
                                                    /> :
                                                    React.cloneElement(DeleteButton, { className: "flex-1 border-[#e8e0d8] text-[#e8a05c] hover:bg-[#f0e6da] hover:text-[#e8a05c]" })

                                            )}
                                        </>
                                }

                            </CardFooter>
                        </Card>
                    )
                }}
                rowSelection={false}
                propsPatch={canPatch}
                propsDelete={true}
                propsPost={false}
                propsWidth={450}
                scroll={{
                    x: "100%",
                }}
                propsUseData={() => {
                    return {
                        postData: reviewPatchController.postData,
                        patchData: (data) => {
                            data = data?.map((value) => {
                                return {
                                    "review_id": value?.review_id,
                                    "review_content": value?.review_content,
                                    "star": value?.star,
                                }
                            })
                            reviewPatchController.patchData(data)
                        },
                        deleteData: reviewPatchController.deleteData,
                    }
                }}

            />
        </Col>
    </Row>)
}

export default BookReviews

